import { createSlice } from "@reduxjs/toolkit";

const initialState = {	
	endpoint: {
		domain: "",
		dashboard: {
			completedCourses: "",
			trainingHours: "",
			certificates: "",
			runningCourses: "",
			runningActions: "",
			notifications: "",
			donutChart: "",
		},
		actionDetails: "",
		courseDetails: "",
		courseCompletionDetails: "",
		myCourses: "",
		coursesCatalog: "",
		coursesCatalogSearch: "",
		catalogDetails: "",
		courseEnrollRequest: "",
		moduleEnrollRequest: "",
		harmonizeToken: "",
	},
};

const apiConfigSlice = createSlice({
	name: "apiConfig",
	initialState: initialState,
	reducers: {
		updateApiConfig(state, action) {
			// console.log("update apiConfig");
			// console.log(action);

			state.endpoint = action.payload.endpoint;
		},
	},
});

export const apiConfigActions = apiConfigSlice.actions;

export default apiConfigSlice;
